import { render, staticRenderFns } from "./ExtruderMachineView.vue?vue&type=template&id=077f7024&"
import script from "./ExtruderMachineView.vue?vue&type=script&lang=js&"
export * from "./ExtruderMachineView.vue?vue&type=script&lang=js&"
import style0 from "./ExtruderMachineView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports